import React, { Component } from "react"

import { Collapse } from 'react-collapse'
import { LogEvent } from "@learningblocks/shared-components";

// Styles
//import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss';
import "./style.scss"

//Icons
import IconNotebook from "@learningblocks/protocol-constants/lib/Icons/notebook-solid";
//import IconHexagon from "@learningblocks/protocol-constants/lib/Icons/hexagon-solid";
//import IconStart from "@learningblocks/protocol-constants/lib/Icons/start-solid";

export class NotesView extends Component {

    renderNotes = () => {
      //Return list of tasks for rendering
      let noteCounter = 0;
      let notes = (this.props.tasks.map((page, pageIndex)=>{
        return (<div className="notes-list">
          {page.tasks.map((task, taskIndex)=>{
            let innerCounter = 0;
            let taskComp = (<div>
              <p className="note-task">{(pageIndex + 1)+'.'+String.fromCharCode(97 + taskIndex)+' '+task.task}</p>
              <div>
                {task.notes.map((note, noteIndex)=>{
                  innerCounter++
                  noteCounter++
                  return (<p className="note-text">{note}</p>)
                })}
              </div>
            </div>)

            if(innerCounter > 0){
              return taskComp
            }
            return null;
          })}
        </div>)
      }))

      if(noteCounter > 0){
        return notes
      } else {
        return (
            <p className="notes-list">
              No notes found
            </p>
        )
      }
    }

    hideNotesView = () => {
      this.props.toggleNotesView(false);
    }


    render() {
        return (
          <Collapse
            isOpened={this.props.notesView}
            theme={{ collapse: 'notes-collapse', content: 'notes-content' }}
            fixedHeight={(window.innerHeight - 100)}>
              <div className="notes-view">
                <div className="notes-head">
                  <div className="back-button">
                    <span>{"< "}</span>
                    <LogEvent
                      logEventProps={{
                        event_type: "sim_protocol_close_notes_btn clicked",
                        event_schema: "track"
                      }}
                      actionProps={{ onClick: { action: 'click' } }}
                      elementType="button"
                    >
                      <button className="back-to-protocol" onClick={this.hideNotesView}>Back to Protocol</button>
                    </LogEvent>
                  </div>
                  <h3>
                    <IconNotebook
                      style={{ color: "white", height: "20px", top: "2px"}}
                    /> Notes
                  </h3>
                </div>
                <div className="notes-body" tabIndex={1}>
                  {this.renderNotes()}
                </div>
              </div>
          </Collapse>
        );
    }
}


NotesView.defaultProps = {
    tasks: []
};
